import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import AssetsConfigModal from "./modules/AssetsConfigModal";
export default {
  name: 'AssetEquipmentRepairList',
  mixins: [JeecgListMixin, GetSiteIdMixin],
  components: {
    AssetsConfigModal: AssetsConfigModal
  },
  data: function data() {
    return {
      pagePath: '/ea/asset/info/querySiteAsset',
      pageTitle: '站点库存',
      autoLoadInit: false,
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点',
        align: 'center',
        sorter: true
      },
      // 表头
      columns1: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'assetCode',
        colName: 'asset_code',
        title: '资产编号',
        align: 'center'
      }, {
        dataIndex: 'name',
        colName: 'name',
        title: '产品名称',
        align: 'center'
      }, {
        dataIndex: 'category_dictText',
        colName: 'category',
        title: ' 产品类别',
        align: 'center'
      }, {
        dataIndex: 'quantity',
        colName: 'quantity',
        title: ' 库存量',
        align: 'center'
      }, {
        dataIndex: 'unit_dictText',
        colName: 'unit',
        title: '产品单位',
        align: 'center'
      }, {
        dataIndex: 'status_dictText',
        colName: 'status',
        title: '资产状态',
        align: 'center'
      }, {
        dataIndex: 'insideNumber',
        colName: 'insideNumber',
        title: '内部编号',
        align: 'center'
      }, {
        dataIndex: 'insideName',
        colName: 'insideName',
        title: '内部名字',
        align: 'center'
      }, {
        dataIndex: 'location',
        colName: 'location',
        title: '安装位置',
        align: 'center'
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      // 表头
      columns2: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'assetCode',
        colName: 'asset_code',
        title: '资产编号',
        align: 'center'
      }, {
        dataIndex: 'name',
        colName: 'name',
        title: '产品名称',
        align: 'center'
      }, {
        dataIndex: 'category_dictText',
        colName: 'category',
        title: ' 产品类别',
        align: 'center'
      }, {
        dataIndex: 'quantity',
        colName: 'quantity',
        title: ' 库存量',
        align: 'center'
      }, {
        dataIndex: 'unit_dictText',
        colName: 'unit',
        title: '产品单位',
        align: 'center'
      }, {
        dataIndex: 'status_dictText',
        colName: 'status',
        title: '资产状态',
        align: 'center'
      }]
    };
  },
  watch: {
    currentSiteId: function currentSiteId(value) {
      if (this.category == 11 || this.category == 12) {
        this.columns = this.columns1;
      } else {
        this.columns = this.columns2;
      }

      var ids = this.getTreeCurrentId();
      this.queryParam.scopeId = ids[1];
      this.queryParam.scope = ids[0];
      this.queryParam.category = this.category;

      if (ids[0] == 1) {
        // 根据站点id
        this.queryParam.siteId = ids[1];
        this.spliceColumn(this.siteColumn);
      } else {
        // 根据区域id
        this.queryParam.siteId = undefined;
        this.spliceColumn(this.siteColumn, 1);
      }

      this.delayLoadData();
    }
  },
  props: {
    category: {
      type: Number,
      default: 0
    }
  },
  created: function created() {
    if (this.category == 11 || this.category == 12) {
      this.column = this.columns1;
    } else {
      this.column = this.columns2;
    }
  },
  computed: {},
  methods: {
    searchReset: function searchReset() {
      var param = JSON.parse(JSON.stringify(this.queryParam));
      this.queryParam = {};
      this.queryParam.category = this.category;

      if (param.scopeId && param.siteId) {
        this.queryParam.scopeId = param.scopeId;
        this.queryParam.scope = param.scope;
        this.queryParam.siteId = param.siteId;
      } else if (param.scopeId) {
        this.queryParam.scopeId = param.scopeId;
        this.queryParam.scope = param.scope;
      } else if (param.siteId) {
        this.queryParam.siteId = param.siteId;
      }

      this.dates = {};
      this.searchResetImpl();

      if (this.$refs.page) {
        this.$refs.page.resetPage();
      } else {
        this.loadData(1);
      }
    },
    handleEdit: function handleEdit(record) {
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = this.pageTitle;
      this.$refs.modalForm.disableSubmit = false;
    },
    modalFormOk: function modalFormOk() {
      this.loadData();
    }
  }
};